export default __webpack_public_path__ + "static/6-339e0ecda0a735153c1002ea8e5e2da7.png";